import { useEffect } from 'react';
import classNames from 'classnames';

import { useToasts } from 'dibs-toaster/exports/useToasts';

import { SbSharedFavoritesNudgeToastContent } from './SbSharedFavoritesNudgeToastContent';
import { useFavoritesNudge } from '../useFavoritesNudge';
import { getFavoritesNudgeDisplayedCount } from '../helpers/getFavoritesNudgeDisplayedCount';
import { trackFavoritingNudgeDisplayed, trackFavoritingNudgeDismissed } from '../tracking';

import dibsCss from 'dibs-css';
import styles from './SbSharedFavoritesNudgeToast.scss';

const useSbSharedFavoritesNudgeToast = ({
    userId,
    showNudge,
}: {
    userId: string;
    showNudge: boolean;
}): { isVisible: boolean } => {
    const { addToast } = useToasts();
    const { isVisible, hideNudge } = useFavoritesNudge({
        userId,
        itemId: null,
        showNudge,
    });

    useEffect(() => {
        if (isVisible) {
            addToast({
                toast: {
                    type: 'basic',
                    position: 'bottomRight',
                    showCloseButton: true,
                    hideTimeoutBar: true,
                    closeAfterTimeout: false,
                    zIndex: 'belowNav',
                    withCustomBackground: true,
                    className: classNames(
                        dibsCss.overflowHidden,
                        dibsCss.bgTangerine100,
                        styles.rotatingGradientBorder
                    ),
                    closeClassName: classNames(styles.close, dibsCss.fillSatan, dibsCss.zLow),
                    children: <SbSharedFavoritesNudgeToastContent />,
                    onClose: () => {
                        trackFavoritingNudgeDismissed({
                            trigger:
                                getFavoritesNudgeDisplayedCount() > 1
                                    ? 'sb longview'
                                    : 'first sb view',
                        });
                        hideNudge();
                    },
                },
            });
            trackFavoritingNudgeDisplayed({
                trigger: getFavoritesNudgeDisplayedCount() > 1 ? 'sb longview' : 'first sb view',
            });
        }
    }, [isVisible, addToast, hideNudge]);

    return { isVisible };
};

export { useSbSharedFavoritesNudgeToast };
